module.exports = __webpack_public_path__ + "img/jyf_jbzq4075-1997.prt.dfc037d3.jpg";